import Engine from './components/Engine'
import './App.css';
import './styles/styles.sass';

function App() {
  return (
    <div className="App">
      <Engine/>
    </div>
  );
}

export default App;
